module.exports = __webpack_public_path__ + "static/media/deborah-scaled.e49e5b3a.png";